import React from 'react';
import copy from 'fast-copy';
import i18next from 'i18next';
import { toast } from 'react-toastify';
import { arrayMoveImmutable } from 'array-move';

// const ExcelJS = require('exceljs');
import * as ExcelJS from 'exceljs';
import * as XLSX from 'xlsx';
// import FileSaver from 'file-saver';
import {saveAs} from "file-saver"; 

// import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';

// import { PDFDocument } from '../Shared/pdfkit.standalone';

import { jsPDF } from 'jspdf';
// import html2canvas from 'html2canvas';


// import BeatLoader from 'react-spinners/BeatLoader';
import { devicesTypeValues } from '../Shared/utils';
// import { decodeHTMLEntities } from '../Functions/utils';

// import swal from '@sweetalert/with-react';
import Swal from 'sweetalert2'

import '../Components/SweetAlert.css'


import { updateSettings } from './user';
import { updateColumns, updateColumnsForModule, updateSortModel, updateSortModelForModule } from './columns';

const line_separator = " / ";
const fixAndParse = (inText) => {
  let fixed = inText;

  fixed = fixed.replace(/[^\x20-\x7F]/g, x => "\\u" + ("000" + x.codePointAt(0).toString(16)).slice(-4));

  fixed = fixed.replace(/\\/g, '\\\\');
  fixed = fixed.replace(/\n/g, ' ');
  fixed = fixed.replace(/\r/g, ' ');
  fixed = fixed.replace(/\t/g, '   ');
  fixed = fixed.replace(/&lt;/g, '<');
  fixed = fixed.replace(/&gt;/g, '>');
  fixed = fixed.replace(/&amp;/g, '&');

  try {
    let jsonFixed = JSON.parse(fixed);

    for (const key of Object.keys(jsonFixed)) {
      jsonFixed[key] = jsonFixed[key].replace(/&quot;/g, '\"');
      jsonFixed[key] = jsonFixed[key].replace(/&apos;/g, '\'');

      var r = /\\u([\d\w]{4})/gi;
      jsonFixed[key] = jsonFixed[key].replace(r, function (match, grp) {
        return String.fromCharCode(parseInt(grp, 16));
      });
    }
    return jsonFixed;
  }
  catch (e) {
    console.log("41 - Error=", e, inText, fixed);
  }
  return {};
}


export const getPreciseTime = (period, type) => {
  
  let newTime = new Date();

  if (period.includes(',')) { // if time is already manually set
    newTime = Number(period.split(',')[type === 'start' ? 0 : 1]);
    return new Date(newTime).getTime();
  }
  else {
    if (type === 'start') {

      // let time = 0;
      let offset; // = new Date().setHours(0, 0, 0, 0) - (time * 86400000);

      // console.log("24 - period=", period);
      switch (period) {
        default:
        case "0": {         // today
          offset = new Date().setHours(0, 0, 0, 0);
          break;
        }

        case "-1":          // yesterday
        case "24": {        // Last 24 hours
          offset = new Date().setHours(0, 0, 0, 0) - (86400000);
          break;
        }

        case "0w": {        // current_week
          const prevMonday = new Date();
          prevMonday.setDate(prevMonday.getDate() - (prevMonday.getDay() + 6) % 7);
          offset = new Date(prevMonday).setHours(0, 0, 0, 0);
          break;
        }

        case "7": {         // Last 7 days
          offset = new Date().setHours(0, 0, 0, 0) - (7 * 86400000);
          break;
        }

        case "-1w": {       // previous_week
          const prevMonday = new Date();
          prevMonday.setDate(prevMonday.getDate() - (prevMonday.getDay() + 6) % 7 - 7);
          offset = new Date(prevMonday).setHours(0, 0, 0, 0);
          break;
        }

        case "0m": {        // current_month
          const now = new Date();
          offset = new Date(now.getFullYear(), now.getMonth(), 1);
          break;
        }

        case "30": {        // Last 30 days
          offset = new Date().setHours(0, 0, 0, 0) - (30 * 86400000);
          break;
        }

        case "-1m": {       // previous_month
          const now = new Date();
          offset = new Date(now.getFullYear(), now.getMonth() - 1, 1);
          break;
        }

        case "60": {        // Last 60 days
          offset = new Date().setHours(0, 0, 0, 0) - (60 * 86400000);
          break;
        }

        case "6m": {        // Last 6 month
          const now = new Date();
          offset = new Date(now.getFullYear(), now.getMonth() - 6, 1);
          break;
        }
      }

      // newTime = new Date(new Date(offset).getTime() + Math.abs(new Date(offset).getTimezoneOffset() * 60000)).toJSON().slice(0, 10);
      newTime = new Date(new Date(offset).getTime() + Math.abs(new Date(offset).getTimezoneOffset() * 60000));
      newTime.setHours(0, 0, 0, 0);

    } else {

      let offset; // = new Date().setHours(0, 0, 0, 0) - (time * 86400000);

      // console.log("95 - period=", period);
      switch (period) {
        default:
        case "24":          // Last 24 hours
        case "0w":          // current_week
        case "0m":          // current month
        case "7":           // Last 7 days
        case "30":          // Last 30 days
        case "60":          // Last 60 days
        case "6m":          // Last 6 month
        case "0": {         // today
          offset = Date.now();
          break;
        }

        case "-1": {          // yesterday
          offset = new Date().setHours(0, 0, 0, 0) - (86400000);
          break;
        }

        case "-1w": {       // previous_week
          const prevMonday = new Date();
          prevMonday.setDate(prevMonday.getDate() - (prevMonday.getDay() + 7) % 7);
          offset = new Date(prevMonday).setHours(0, 0, 0, 0);
          break;
        }

        case "-1m": {       // previous_month
          const now = new Date();
          offset = new Date(now.getFullYear(), now.getMonth(), 0);
          break;
        }
      }

      // newTime = new Date(new Date(offset).getTime() + Math.abs(new Date(offset).getTimezoneOffset() * 60000)).toJSON().slice(0, 10);
      newTime = new Date(new Date(offset).getTime() + Math.abs(new Date(offset).getTimezoneOffset() * 60000));
      newTime.setHours(0, 0, 0, 0);
    }
  }

  return newTime.getTime();
};


export const changeSettings = (t, type, value, settings, appDispatch) => {
  if (type === 'lang') i18next.changeLanguage(value);

  const newSettings = { ...settings, [type]: value };
  appDispatch({ settings: newSettings });

  // console.log("38 - newSettings=", newSettings);
  updateSettings(newSettings).then(res => !res.success &&
    toast(decodeHTMLEntities(t('settings.errors.' + type)), { type: 'error' })
  );
};

export const toggleSidebar = (sidebar, dispatch) => (
  dispatch({ sidebar: !sidebar })
);


export const multiSelectStrings = (t, type, selected) => {
  let selectSomeItems;
  if (type === 'grp')
    selectSomeItems = t('global.multi_select.select_group');
  else if (type === 'loc')
    selectSomeItems = t('global.multi_select.' + (selected.groups.length > 0 ? 'select_location' : 'no_group'));
  else
    selectSomeItems = t('global.multi_select.select_some_items')

  return {
    selectSomeItems,
    search: t('global.multi_select.search'),
    selectAll: t('global.multi_select.select_all'),
    noOptions: t('global.multi_select.no_options'),
    clearSearch: t('global.multi_select.clear_search'),
    selectAllFiltered: t('global.multi_select.select_all_filtered'),
    allItemsAreSelected: t('global.multi_select.all_items_are_selected')
  }
};


export const getSelectedLocations = (allLocations, sites) => {
  const locations = [];

  sites.forEach(loc => {
    if (loc.group) return locations.push(loc.value);

    // -> CANNOT SELECT ANYMORE GROUP IN LOCATIONS SELECTER
    // return the group's locations if the selected item is a group
    //return allLocations.filter(all => all.group === loc.value).forEach(site => locations.push(site.value));    
  });

  // [...new Set()] removes duplicates from the array if any
  return [...new Set(locations)];
};

export const getSelectedGroups = (allGroups, sites) => {
  const groups = [];

  sites.forEach(grp => {
    return groups.push(grp.value);
  });
  return [...new Set(groups)];
};


// DEPLOYMENT FUNCTIONS
export const getDeploymentDateTime = (datetime) => {

  // console.log("238 - getDeploymentDateTime=", datetime);

  if (!datetime) {
    datetime = String(
      new Date(
        new Date().getTime() + Math.abs(new Date().getTimezoneOffset() * 60000)
      ).toISOString()
    );
  }

  const date = datetime.split('T')[0];
  const time = datetime.split('T')[1].slice(0, 8);

  // console.log("251 - time=", time);
  // console.log("252 - date=", date);

  return {
    time,
    day: date.slice(8),
    year: date.slice(0, 4),
    month: date.slice(5, 7)
  };
};



export const getTimeAsZDateTime = (datetime) => {

  if (!datetime) {
    return null;
  }
  const fixedDate = new Date(datetime).valueOf() + (new Date(datetime).getTimezoneOffset() * 60 * 1000);
  return new Date(fixedDate).toJSON();
};


export const xlsxDownload = ({ header, content, filename }) => {
  // console.log("103 - format=", header);
  // console.log("104 - data=", content);
  // console.log("105 - content=", filename);


  // Building correct data for the XLSX file
  const data = XLSX.utils.sheet_add_dom(XLSX.utils.table_to_sheet(header), content, { origin: -1 });
  const format = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

  // console.log("106 - format=", format);
  // console.log("107 - data=", data);
  // console.log("108 - content=", content);


  // Downloading the XLSX file
  const writeBuffer = { Sheets: { data }, SheetNames: ['data'] };
  const excelBuffer = XLSX.write(writeBuffer, { bookType: 'xlsx', type: 'array' });
  const excelData = new Blob([excelBuffer], { type: format });

  saveAs(excelData, filename + '.xlsx');
};


// USED IN ALL EXPORTS.JS
export const xlsxDownload4 = async ({ csv, filename }) => {

  const parsed = CSV.parse(csv);
  // console.log("263 - CSV parsed=", parsed);

  var data = XLSX.utils.aoa_to_sheet(parsed);
  // console.log("356 - filteredParsed data added...");

  const format = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

  // Downloading the XLSX file
  // const writeBuffer = { Sheets: { data }, SheetNames: ['data'] };
  // const excelBuffer = XLSX.write({ Sheets: { data }, SheetNames: ['data'] }, { bookType: 'xlsx', type: 'array' });
  // console.log("363 - excelBuffer written...");

  let dataWritten;
  let excelData;
  const p = new Promise((resolve) => {

    setTimeout(() => {

      dataWritten = XLSX.write({ Sheets: { data }, SheetNames: ['data'] }, { bookType: 'xlsx', type: 'array' });
      excelData = new Blob([dataWritten], { type: format });
      saveAs(excelData, filename + '.xlsx');

      resolve('dataWritten done');
    }, 5);

  });

  // console.log("386 - promise XLSX.write...");
};



// NOT USED
export const xlsxDownload2 = async ({ csv, lang, filename, dashboardText, printedColumns, period, t, reportingColumns, label }) => {

  // console.log("260 - start xlsxDownload2 process");

  const parsed = CSV.parse(csv);
  // console.log("263 - CSV parsed");

  // console.log("262 - reportingColumns=", reportingColumns);

  let serialText = '';
  let serialKey = -1;
  reportingColumns.every((col, key) => {
    if (col.field === 'system_$$_serial_number') {
      serialText = col.headerName;
      serialKey = key;
      return false;
    }
    return true;
  });
  // console.log("273 - serialText=", serialText, serialKey);

  const tmp = [];
  if (serialKey !== -1) {
    for (let i = 1; i < parsed.length; i++) {
      const line = parsed[i];
      const found = tmp.find((text) => {
        return text === line[serialKey];
      });
      if (!found) {
        tmp.push(line[serialKey]);
      }
    }
  }
  // console.log("191 - tmp=", tmp, tmp.length);

  let filteredParsedCount = 0;
  const filteredParsed = [];
  parsed.forEach(line => {
    const filteredLine = [];
    for (let i = 0; i < line.length; i++) {
      if (printedColumns.indexOf(i) !== -1) {
        filteredLine.push(line[i]);
      }
    }
    filteredParsedCount++;
    filteredParsed.push(filteredLine);
  });

  const dateOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: 'numeric',
    minute: '2-digit'
  };
  const currentDate = new Date().toLocaleDateString(lang ? lang : 'en', dateOptions);

  const start = getPreciseTime(period, 'start');
  const end = getPreciseTime(period, 'end');
  const startDate = new Date(new Date(+start).getTime() + Math.abs(new Date(+start).getTimezoneOffset() * 60000)).toJSON().slice(0, 10);
  const endDate = new Date(new Date(+end).getTime() + Math.abs(new Date(+end).getTimezoneOffset() * 60000)).toJSON().slice(0, 10);

  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  };


  // console.log("321 - tmp=", filteredParsed, filteredParsed.length, t('reporting.print.devices') + ": " + (filteredParsed.length - 1));

  var Heading = [
    ["SoftThinks", dashboardText],
    ["Reporting - " + currentDate],
    [t('reporting.print.from') + " " + new Date(getTimeAsZDateTime(startDate)).toLocaleDateString(lang ? lang : 'en', options) + " " + t('reporting.print.to') + " " + new Date(getTimeAsZDateTime(endDate)).toLocaleDateString(lang ? lang : 'en', options)],
    [label],
    [t('reporting.print.devices') + ": " + (filteredParsed.length - 1)]
  ];

  // console.log("328 - tmp=", tmp, tmp.length, t('reporting.print.different_devices') + ": " + tmp.length);
  if (tmp.length > 0) {
    Heading.push(
      [t('reporting.print.different_devices') + ": " + tmp.length]
    )
  }

  Heading.push(
    ["", ""]
  )

  var data = XLSX.utils.aoa_to_sheet(Heading);
  // console.log("346 - heading data done...");

  // console.log("161 - filteredParsed=", filteredParsed);

  XLSX.utils.sheet_add_aoa(data, filteredParsed, {
    header: ["", ""],
    skipHeader: true,
    origin: -1
  });

  // console.log("356 - filteredParsed data added...");

  const format = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

  // Downloading the XLSX file
  // const writeBuffer = { Sheets: { data }, SheetNames: ['data'] };
  // const excelBuffer = XLSX.write({ Sheets: { data }, SheetNames: ['data'] }, { bookType: 'xlsx', type: 'array' });
  // console.log("363 - excelBuffer written...");

  let dataWritten;
  let  excelData;
  const p = new Promise((resolve) => {

    setTimeout(() => {

      dataWritten = XLSX.write({ Sheets: { data }, SheetNames: ['data'] }, { bookType: 'xlsx', type: 'array' });      
      // console.log("371 - dataWritten  done...");

      excelData = new Blob([dataWritten], { type: format });
      // console.log("369 - excelBuffer blob done...", excelData.size);

  saveAs(excelData, filename + '.xlsx');
      // console.log("372 - saveAs done...");

      resolve('dataWritten done');
    }, 5);

  });

  // console.log("386 - promise XLSX.write...");
  // let  excelData;
  // await new Promise((resolve) => {
  //   setTimeout(() => {

  //     excelData = new Blob([dataWritten], { type: format });
  //     console.log("369 - excelBuffer blob done...", excelData.size);

  //     resolve('excelBuffer done');
  //   }, 50);
  // });

  // await new Promise((resolve) => {
  //   setTimeout(() => {
  //     saveAs(excelData, filename + '.xlsx');
  //     console.log("372 - saveAs done...");

  //     resolve('saveAs done');
  //   }, 50);
  // });
};




export const xlsxDownload3 = async ({
  csv, lang, filename, dashboardText, printedColumns, period, t, reportingColumns, label, scenarioType = devicesTypeValues.PCs,
  deployments, rows, scenario, selectionModel, uniqueCount
}) => {
  const parsed = CSV.parse(csv);

  Swal.update({
    html: t('reporting.export.in_progress') + t('reporting.export.parse_data'),
  });

  const selectedRows = selectionModel.length === 0 ? rows : rows.filter((row) => {
    return selectionModel.includes(row.key + 1);
  });

  const filteredDeployments = [];
  for (const row of selectedRows) {
    const dep = deployments[row.key];
    filteredDeployments.push(dep);
          }

  const tmpArrayForUnique = [];
  for (const dep of filteredDeployments) {
    const found = tmpArrayForUnique.find(d => {
      if (
        d && dep &&
        (
          (scenario.devicesType === devicesTypeValues.PCs && d.system_serial === dep.system_serial)
          ||
          (scenario.devicesType === devicesTypeValues.disks && d.serial === dep.serial)
        )
      ) {
        const cpuListDep = dep.cpu_data && dep.cpu_data.split('<cpu>');
        let cpuModelDep = "";
        if (cpuListDep) {
          cpuListDep.forEach(cpu => {
            const cpuData = fixAndParse(cpu);
            if (cpuData.model !== "") {
              if (cpuModelDep !== "")
                cpuModelDep = cpuModelDep + line_separator;
              cpuModelDep += cpuData.model;
    }
          });
    }

        const cpuListD = d.cpu_data && d.cpu_data.split('<cpu>');
        let cpuModelD = "";
        if (cpuListD) {
          cpuListD.forEach(cpu => {
            const cpuData = fixAndParse(cpu);
            if (cpuData.model !== "") {
              if (cpuModelD !== "")
                cpuModelD = cpuModelD + line_separator;
              cpuModelD += cpuData.model;
    }
  });
    }

              if (
          d.system_uuid === dep.system_uuid &&
          d.motherboard_model === dep.motherboard_model &&
          cpuModelD === cpuModelDep
              ) {
                return true;
              }
            }
            return false;
          });

          if (!found) {
      tmpArrayForUnique.push(dep);
    }
  }

  Swal.update({
    html: t('reporting.export.in_progress') + t('reporting.export.setting_header'),
  });

  const dateOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: 'numeric',
    minute: '2-digit'
  };
  const currentDate = new Date().toLocaleDateString(lang ? lang : 'en', dateOptions);

  const start = getPreciseTime(period, 'start');
  const end = getPreciseTime(period, 'end');
  const startDate = new Date(new Date(+start).getTime() + Math.abs(new Date(+start).getTimezoneOffset() * 60000)).toJSON().slice(0, 10);
  const endDate = new Date(new Date(+end).getTime() + Math.abs(new Date(+end).getTimezoneOffset() * 60000)).toJSON().slice(0, 10);

  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  };

  let filteredParsedCount = 0;
  parsed.forEach(line => {
    const filteredLine = [];
    for (let i = 0; i < line.length; i++) {
      if (printedColumns.indexOf(i) !== -1) {
        filteredLine.push(line[i]);
      }
    }
    filteredParsedCount++;
  });

  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet('data');

  sheet.addRow(["SoftThinks", dashboardText]);
  sheet.addRow(["", ""]);
  sheet.addRow(["Reporting - " + currentDate]);
  sheet.addRow([t('reporting.print.from') + " " + new Date(getTimeAsZDateTime(startDate)).toLocaleDateString(lang ? lang : 'en', options) + " " + t('reporting.print.to') + " " + new Date(getTimeAsZDateTime(endDate)).toLocaleDateString(lang ? lang : 'en', options)]);
  sheet.addRow([label]);

  if (scenarioType === devicesTypeValues.disks) {
    sheet.addRow([t('reporting.print.disks') + ": " + (filteredParsedCount - 1)]);

    if (tmpArrayForUnique.length > 0) {
      sheet.addRow([t('reporting.print.different_disks') + ": " + tmpArrayForUnique.length]);
    }
  }
  else {
  sheet.addRow([t('reporting.print.devices') + ": " + (filteredParsedCount - 1)]);

  if (tmpArrayForUnique.length > 0) {
    sheet.addRow([t('reporting.print.different_devices') + ": " + tmpArrayForUnique.length]);
  }
  }



  sheet.addRow(["", ""]);
  Swal.update({
    html: t('reporting.export.in_progress') + t('reporting.export.setting_rows'),
  });


  let latestChrono = Date.now();

  for (let i = 0; i < parsed.length; i++) {
    await new Promise((resolve) => {
      const line = parsed[i];
      setTimeout(() => {
        const filteredLine = [];
        for (let i = 0; i < line.length; i++) {
          if (printedColumns.indexOf(i) !== -1) {
            filteredLine.push(line[i].toString());
          }
        }
        // console.log("655 - filteredLine=", filteredLine);
        sheet.addRow(filteredLine);
        resolve('addRow done');
      }, 1);
    });

    const curChrono = Date.now();
    if (curChrono > (latestChrono + 1000)) {
      // console.log("685 - curChrono=", (curChrono - latestChrono) / 1000);
      Swal.update({
        html: t('reporting.export.in_progress') + t('reporting.export.setting_rows') + "... " + i + "/" + (parsed.length-1) + "."
      });
      latestChrono = curChrono;
  }


    // console.log("685 - curChrono - startChrono) / 1000=", (curChrono - startChrono) / 1000);
    // if (
    //   ((curChrono - startChrono) / 1000) % 1 === 0
    // ) {
    //   console.log("685 - curChrono - startChrono) / 1000=", (curChrono - startChrono) / 1000);
    //   Swal.update({
    //     html: t('reporting.export.in_progress') + t('reporting.export.setting_rows') + "... " + i,
    //   });
    // }
  }


  // Swal({
  //   title: t('global.dialog_title'),
  //   text: t('reporting.export.in_progress') + t('reporting.export.building_buffer'),
  //   button: false,
  //   closeOnClickOutside: false,
  //   closeOnEsc: false,
  //   content: (
  //     <BeatLoader color={colors.softthinks} />
  //   )
  // });


  Swal.update({
    html: t('reporting.export.in_progress') + t('reporting.export.building_buffer'),
  });

  // Swal.fire({
  //   allowOutsideClick: false,
  //   title: t('global.dialog_title'),
  //   html: t('reporting.export.in_progress') + t('reporting.export.building_buffer'),
  //   showCancelButton: false,
  //   showConfirmButton: false,
  //   customClass: {
  //     confirmButton: 'confirm-button-class',
  //     title: 'title-class',
  //     icon: 'icon-class'
  //   }
  // });
  // Swal.showLoading();

  // sheet.eachRow(function (row, rowNumber) {
  //   console.log("-------------------");
  //   console.log('Row ', rowNumber, JSON.stringify(row.values));

  //   row.eachCell(function (cell, colNumber, a, b, c, d) {
  //     cell._column.numFmt = '@';
  //     console.log('   Cell ', colNumber, cell, a, b, c, d);
  //   });
  // });

  // sheet.eachCell(function(cell, rowNumber) {
  //   console.log("523 - cell/rowNumber=", cell, rowNumber);
  // });


  // console.log("537 - rows added");

  const format = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const dataWritten = await workbook.xlsx.writeBuffer();
  
  // console.log("542 - dataWritten...");

  const excelData = new Blob([dataWritten], { type: format });
  // console.log("545 - excelBuffer blob done...", excelData.size);

  Swal.close();

  saveAs(excelData, filename + '.xlsx');
  // console.log("548 - saveAs done...");
};



// XLS => PDF
export const xlsxDownloadToPdf = async ({ csv, lang, filename, dashboardText, printedColumns, period, t, reportingColumns, label }) => {

  const parsed = CSV.parse(csv);

  Swal.update({
    html: t('reporting.export.in_progress') + t('reporting.export.parse_data'),
  });

  let serialText = '';
  let serialKey = -1;
  reportingColumns.every((col, key) => {
    if (col.field === 'system_$$_serial_number') {
      serialText = col.headerName;
      serialKey = key;
      return false;
    }
    return true;
  });

  const tmp = [];
  if (serialKey !== -1) {
    for (let i = 1; i < parsed.length; i++) {

      await new Promise((resolve) => {
        setTimeout(() => {
          const line = parsed[i];
          const found = tmp.find((text) => {
            return text === line[serialKey];
          });
          if (!found) {
            tmp.push(line[serialKey]);
          }
          resolve('dataWritten done');
        }, 1);
      });

    }
  }

  Swal.update({
    html: t('reporting.export.in_progress') + t('reporting.export.setting_header'),
  });

  const dateOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: 'numeric',
    minute: '2-digit'
  };
  const currentDate = new Date().toLocaleDateString(lang ? lang : 'en', dateOptions);

  const start = getPreciseTime(period, 'start');
  const end = getPreciseTime(period, 'end');
  const startDate = new Date(new Date(+start).getTime() + Math.abs(new Date(+start).getTimezoneOffset() * 60000)).toJSON().slice(0, 10);
  const endDate = new Date(new Date(+end).getTime() + Math.abs(new Date(+end).getTimezoneOffset() * 60000)).toJSON().slice(0, 10);

  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  };

  let filteredParsedCount = 0;
  parsed.forEach(line => {
    const filteredLine = [];
    for (let i = 0; i < line.length; i++) {
      if (printedColumns.indexOf(i) !== -1) {
        filteredLine.push(line[i]);
      }
    }
    filteredParsedCount++;
  });


  const body = `
  <body>
  <p style="text-indent: 0pt;text-align: left;"><br/></p>
  <table style="border-collapse:collapse;margin-left:5.08465pt" cellspacing="0">
     <tr style="height:9pt">
        <td style="width:124pt" colspan="2">
           <p class="s1" style="padding-left: 1pt;text-indent: 0pt;line-height: 7pt;text-align: left;">Report Date <span class="s2">- 02/20/2025, 4:05 PM</span></p>
        </td>
        <td style="width:84pt" colspan="2">
           <p class="s1" style="padding-left: 5pt;text-indent: 0pt;line-height: 8pt;text-align: left;">Erasure Results Summary:</p>
        </td>
        <td style="width:23pt">
           <p style="text-indent: 0pt;text-align: left;"><br/></p>
        </td>
        <td style="width:25pt">
           <p style="text-indent: 0pt;text-align: left;"><br/></p>
        </td>
        <td style="width:35pt">
           <p class="s1" style="padding-left: 21pt;text-indent: 0pt;line-height: 8pt;text-align: left;">Era</p>
        </td>
        <td style="width:228pt" colspan="3" rowspan="2">
           <p class="s3" style="padding-left: 4pt;text-indent: 0pt;line-height: 6pt;text-align: left;">These Erasures conform to the NIST 800-88 rev1 standard by determining Self-Sanitization</p>
           <p class="s3" style="padding-left: 4pt;text-indent: 0pt;text-align: left;">methods that your drive is capable of and executing one that conforms to the specification.</p>
        </td>
     </tr>
  </table>
</body>
    `
    ;

  let doc = new jsPDF('portrait', 'pt', 'a4');

  let info = jsPDF.getPageSize('portrait', 'pt', 'a4');
  console.log('5927 - info=', info);


  //doc.addFont("helvetica", 'bold', "bold");
  //doc.addFont("helvetica", 'normal', "normal");

  //doc.setFont("bold");
  //doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  doc.setTextColor(100);

  let textDimensions = doc.getTextDimensions(["This is the default font.", '123', '456', '789']);
  console.log('835 - textDimensions=', textDimensions);

  doc.text(["This is the default font.", '123', '456', '789'], 20, 20);

  doc.text(["This is the default font.", '123', '456', '789'], 20, 20 + textDimensions.h);

  // let rep = doc.html(body, {
  //   html2canvas: {
  //     // insert html2canvas options here, e.g.
  //     width: 595
  //   },
  //   callback: function (doc) {
  //     console.log("851 - ...");
  //     doc.save();
  //   }
  // });
  // console.log("855 - rep = ", rep);

  // doc.text("This is the default font.", 20, 30);
  // doc.text("This is the default font.", 20, 40);
  // doc.text("This is the default font.", 20, 50);

  // doc.text(20, 20, 'This is gray.');

  // doc.setFont('helvetica', 'normal');

  // doc.setTextColor(150);
  // doc.text(20, 30, 'This is light gray.');

  // doc.setTextColor(255, 0, 0);
  // doc.text(20, 40, 'This is red.');

  // doc.setTextColor(0, 255, 0);
  // doc.text(20, 50, 'This is green.');

  // doc.setTextColor(0, 0, 255);
  // doc.text(20, 60, 'This is blue.');


  doc.save('Test.pdf');




  //------------------------------------------------------------------

  // const doc = new PDFDocument();

  // // add your content to the document here, as usual
  // doc.fontSize(25).text("Some text with standard font!", 100, 100);

  // // Add another page
  // doc
  //   .addPage()
  //   .fontSize(25)
  //   .text("Here is some vector graphics...", 100, 100);

  // // Draw a triangle
  // doc
  //   .save()
  //   .moveTo(100, 150)
  //   .lineTo(100, 250)
  //   .lineTo(200, 250)
  //   .fill("#FF3300");

  // // Apply some transforms and render an SVG path with the 'even-odd' fill rule
  // doc
  //   .scale(0.6)
  //   .translate(470, -380)
  //   .path("M 250,75 L 323,301 131,161 369,161 177,301 z")
  //   .fill("red", "even-odd")
  //   .restore();

  // // Add some text with annotations
  // doc
  //   .addPage()
  //   .fillColor("blue")
  //   .text("Here is a link!", 100, 100)
  //   .underline(100, 100, 160, 27, { color: "#0000FF" })
  //   .link(100, 100, 160, 27, "http://google.com/");

  // // get a blob when you're done
  // doc.end();


  //-------------------------------------------------------------------

  /*
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet('data', { pageSetup: { fitToPage: true, fitToHeight: 5, fitToWidth: 7 } });


  sheet.addRow(["SoftThinks", dashboardText]);
  sheet.addRow(["", ""]);
  sheet.addRow(["Reporting - " + currentDate]);
  sheet.addRow([t('reporting.print.from') + " " + new Date(getTimeAsZDateTime(startDate)).toLocaleDateString(lang ? lang : 'en', options) + " " + t('reporting.print.to') + " " + new Date(getTimeAsZDateTime(endDate)).toLocaleDateString(lang ? lang : 'en', options)]);
  sheet.addRow([label]);
  sheet.addRow([t('reporting.print.devices') + ": " + (filteredParsedCount - 1)]);

  if (tmp.length > 0) {
    sheet.addRow([t('reporting.print.different_devices') + ": " + tmp.length]);
  }

  sheet.addRow(["", ""]);


  Swal.update({
    html: t('reporting.export.in_progress') + t('reporting.export.setting_rows'),
  });

  let latestChrono = Date.now();

  for (let i = 0; i < parsed.length; i++) {
    await new Promise((resolve) => {
      const line = parsed[i];
      setTimeout(() => {
        const filteredLine = [];
        for (let i = 0; i < line.length; i++) {
          if (printedColumns.indexOf(i) !== -1) {
            filteredLine.push(isNaN(line[i]) ? line[i].toString() : Number(line[i]));
          }
        }
        // console.log("517 - filteredLine=", filteredLine);
        const row = sheet.addRow(filteredLine);
        // 
        // row.fill = {
        //   type: 'pattern',
        //   pattern:'solid',
        //   fgColor: { argb:'FFFF0000' },
        //   bgColor: { argb:'FFFF0000' }
        // };

        resolve('addRow done');
      }, 1);
    });

    sheet.getRow(8).font = { name: 'Comic Sans MS', family: 4, size: 24, underline: 'double', bold: true };

    const curChrono = Date.now();
    if (curChrono > (latestChrono + 1000)) {
      // console.log("685 - curChrono=", (curChrono - latestChrono) / 1000);
      Swal.update({
        html: t('reporting.export.in_progress') + t('reporting.export.setting_rows') + "... " + i + "/" + (parsed.length - 1) + "."
      });
      latestChrono = curChrono;
    }
  }

  Swal.update({
    html: t('reporting.export.in_progress') + t('reporting.export.building_buffer'),
  });

  const format = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const dataWritten = await workbook.xlsx.writeBuffer();

  const excelData = new Blob([dataWritten], { type: format });

  const pdfDoc = await PDFDocument.create();
  const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);

  let page = pdfDoc.addPage();
  let { width, height } = page.getSize();
  let y = height - 50; // Start the content below the sheet name

  workbook.eachSheet((worksheet) => {
    const sheetName = worksheet.name;

    page.drawText(sheetName, { x: 50, y: y, font: helveticaFont, size: 20, color: rgb(0, 0, 0) });

    y -= 30; // Move down for the next row

    const columnWidths = [];
    worksheet.eachRow((row) => {
      row.eachCell((cell, colNumber) => {
        const textWidth = helveticaFont.widthOfTextAtSize(cell.text, 8);
        columnWidths[colNumber - 1] = Math.max(columnWidths[colNumber - 1] || 0, textWidth);
      });
    });

    worksheet.eachRow((row, rowIndex) => {
      let x = 10; // Start from the left margin

      if (y < 50) { // If the current page is full, add a new page
        page = pdfDoc.addPage();
        ({ width, height } = page.getSize());
        y = height - 50;
      }

      row.eachCell((cell, colNumber) => {
        const textWidth = helveticaFont.widthOfTextAtSize(cell.text, 8);
        const cellWidth = columnWidths[colNumber - 1] + 20;
        const cellHeight = 20;

        // Draw cell background
        page.drawRectangle({
          x, y: y - cellHeight, width: cellWidth, height: cellHeight,
          color: rowIndex === 1 ? rgb(0.8, 0.8, 0.8) : rgb(1, 1, 1),
          borderColor: rgb(0, 0, 0),
          borderWidth: 0,
        });

        // Draw cell text
        page.drawText(cell.text, {
          x: x + (cellWidth - textWidth) / 2, y: y - cellHeight / 2 - 6,
          font: helveticaFont, size: 8, color: rgb(0, 0, 0),
        });

        x += cellWidth; // Move to the right for the next cell
      });

      y -= 20; // Move down for the next row
    });
  });

  const pdfBytes = await pdfDoc.save();
  //await fs.promises.writeFile(pdfFilePath, pdfBytes);


  Swal.close();

  const pdfData = new Blob([pdfBytes], { type: format });

  saveAs(pdfData, filename + '.pdf');
  */

  //saveAs(excelData, filename + '.xlsx');
  // console.log("548 - saveAs done...");


  Swal.close();
};



export const getUnknownValue = (value, t, e = '') => {
  if (value.toLowerCase() === 'unknown' || value.includes(') - ?')) {
    return t('global.unknown', { e }); // e equals 'e' if the word is feminine in french
  }
  return value;
};



export const getModuleConditionsTextOnly = (conditions) => {
  let index = 0;
  let stack = [];

  for (const [i, condition] of conditions.entries()) {

    const cond = condition.condition;
    // const display_cond = t('scenarios.conditions.operators.' + cond);
    const display_cond = `[OP=\u2042${cond}\u2042]`;

    if (!cond)
      return "";

    const desc = condition.xtra_desc ? `[DESC=\u2042${condition.xtra_desc}\u2042]` : 'NULL';
    const value = condition.xtra_value ? `[VALUE=\u2042${condition.xtra_value}\u2042]` : 'NULL';

    if (condition.xtra_desc === 'FAKE_XTRA_DESC_FOR_WHOLE_MODULE_ABSENT' && condition.condition === 'NONE') {
      return ("")
    }

    switch (cond) {
      case '==':
      case '!=':
      case '<':
      case '>': {
        if (!condition.xtra_desc)
          return ("");

        if (!condition.xtra_value)
          return ("");

        index += 1;
        stack[index] = {
          topLevel: '',
          notation: desc + display_cond + value
        };
        break;
      }

      case 'ANY':
      case 'NONE':
      case 'EMPTY': {
        if (!condition.xtra_desc)
          return ("");

        index += 1;
        stack[index] = {
          topLevel: '',
          notation: desc + display_cond
        };

        break;
      }

      case 'OR':
      case 'AND': {
        if (index < 2)
          return ("")

        else {
          const a = stack[index - 1];
          const b = stack[index];

          const a_val = a.topLevel === cond ? a.notation : '﴾' + (a.notation) + '﴿';
          const b_val = b.topLevel === cond ? b.notation : '﴾' + b.notation + '﴿';

          const item = {
            topLevel: cond,
            notation: a_val + display_cond + b_val
          };

          stack[index - 1] = item;
          index -= 1;
        };

        break;
      }

      default:
        return ("")
    }
  };

  if (index === 1)
    return (stack[1].notation)

  if (index > 1)
    return ("")

  return ("");
};


export const getModuleLines = (conditions) => {

  // console.log("464 - conditions=", conditions);
  if (conditions && conditions.length === 1 && conditions[0].condition === undefined && conditions[0].desc === undefined && conditions[0].value === undefined) {
    return [{
      condition: "",
      desc: "",
      extra: "",
      first: 0,
      last: 0,
      scModuleId: undefined,
      value: undefined,
      seq: 1
    }]
  }

  // const text = '(' + getModuleConditionsTextOnly(conditions) + ')';

  let text = getModuleConditionsTextOnly(conditions);
  if (text && text[0] && text[0] !== '﴾') {
    text = '﴾' + text + '﴿';
  }
  // console.log("465 - conditions=", conditions, text);

  const scModuleId = conditions && conditions[0] && conditions[0].scModuleId;

  //(([DESC="param1"][OP="=="][VALUE="5390416"])[OP="AND"]([DESC="param2"][OP="=="][VALUE="4294901760"]))[OP="OR"]([DESC="closing code"][OP="ANY"])
  let curParenthOpen = 0;
  let curParenthClose = 0;

  let stringInProgress = '';

  let strExtra = "";
  let strFirst = "";
  let strDesc = "";
  let strCond = "";
  let strValue = "";
  let strLast = "";

  let lines = [];

  // "([^"]+)"

  // const regex = /\[([^\]]+)\]/g;  // 
  const regex = /\u2042([^\u2042]+)\u2042/g;  // 

  for (let i = 0; i < text.length; i++) {
    const letter = text[i];

    if (letter === '﴾') {
      curParenthOpen++;
    }
    else if (letter === '﴿') {
      curParenthClose++;
    }
    else {
      if (curParenthOpen) {
        strFirst = (curParenthOpen - 1).toString();
      }
      curParenthOpen = 0;

      if (curParenthClose) {
        strLast = (curParenthClose - 1).toString();

        if (stringInProgress.substring(0, 10) === '[OP=\u2042AND\u2042]') {
          strExtra = "AND";
          stringInProgress = stringInProgress.substring(10);
        }
        else if (stringInProgress.substring(0, 9) === '[OP=\u2042OR\u2042]') {
          strExtra = "OR";
          stringInProgress = stringInProgress.substring(9);
        }

        const tmpExt = stringInProgress.match(regex);
        // console.log("55 - tmpExt=", tmpExt);

        strDesc = tmpExt[0] && tmpExt[0].slice(1, -1);
        strCond = tmpExt[1] && tmpExt[1].slice(1, -1);
        strValue = tmpExt[2] && tmpExt[2].slice(1, -1);

        // console.log("55 - strDesc=", strDesc, strOp, strValue);
        const line = {
          extra: strExtra,
          first: strFirst,
          text: stringInProgress,
          desc: strDesc,
          condition: strCond,
          value: strValue,
          last: strLast,
          scModuleId: scModuleId
        }
        lines.push(line);
        stringInProgress = '';
      }
      curParenthClose = 0;

      stringInProgress = stringInProgress + letter;
    }
  }
  if (curParenthClose) {
    strLast = (curParenthClose - 1).toString();

    if (stringInProgress.substring(0, 10) === '[OP=\u2042AND\u2042]') {
      strExtra = "AND";
      stringInProgress = stringInProgress.substring(10);
    }
    else if (stringInProgress.substring(0, 9) === '[OP=\u2042OR\u2042]') {
      strExtra = "OR";
      stringInProgress = stringInProgress.substring(9);
    }

    const tmpExt = stringInProgress.match(regex);

    strDesc = tmpExt[0] && tmpExt[0].slice(1, -1);
    strCond = tmpExt[1] && tmpExt[1].slice(1, -1);
    strValue = tmpExt[2] && tmpExt[2].slice(1, -1);

    const line = {
      extra: strExtra,
      first: strFirst,
      text: stringInProgress,
      desc: strDesc,
      condition: strCond,
      value: strValue,
      last: strLast,
      scModuleId: scModuleId
    }
    lines.push(line);
    stringInProgress = '';
  }
  return lines;
}


export const getConditionsFromLines = (lines) => {

  let stackarr = [];
  let topp = -1;

  let postfix = [];
  let temp = 0;

  function pushToStack(e) {
    topp++;
    stackarr[topp] = e;
  }

  // Pop function for returning top element
  function popFromStack() {
    if (topp === -1)
      return 0;
    else {
      const popped_ele = stackarr[topp];
      topp--;

      return popped_ele;
    }
  }

  function precedency(pre) {
    if (pre === '@' || pre === '﴾' || pre === '﴿') {
      return 1;
    }
    else if (pre === 'OR') {
      return 2;
    }
    else if (pre === 'AND') {
      return 3;
    }
    return 0;
  }


  function checkP(lines) {
    let totalP = 0;

    // console.log("636 - lines=", lines);
    // if (lines === undefined)
    //   return 0;

    for (const line of lines) {
      totalP = totalP + parseInt(line.first, 0);
      totalP = totalP - parseInt(line.last, 0);
    }
    return totalP;
  }

  if (lines === undefined)
    return postfix;

  if (checkP(lines) !== 0)
    return postfix;

  pushToStack('@');

  let scModuleId = "";
  for (const line of lines) {

    if (scModuleId === "")
      scModuleId = line.scModuleId;

    // console.log("617 - line=", line.extra, line.first, line.desc, line.condition, line.value, line.last);    

    // if (line.extra || line.first || line.last) {
    if (line.extra) {

      // console.log("625 - line.extra=", line.extra, stackarr[topp], precedency(line.extra) > precedency(stackarr[topp]));
      if (precedency(line.extra) > precedency(stackarr[topp])) {
        pushToStack(line.extra);
      }
      else {
        while (precedency(line.extra) <=
          precedency(stackarr[topp]) && topp > -1) {

          let li = {
            xtra_desc: "",
            condition: popFromStack(),
            xtra_value: "",
            scModuleId: scModuleId
          }
          postfix[temp++] = li; //popFromStack();
        }
        pushToStack(line.extra);
      }
    }

    if (line.first) {
      // console.log("640 - line.first=", line.first);
      for (let i = 0; i < parseInt(line.first, 10); i++) {
        pushToStack('﴾');
      }
    }

    let li = {
      xtra_desc: line.desc,
      condition: line.condition,
      xtra_value: (line.value ? line.value : ""),
      scModuleId: scModuleId
    }
    postfix[temp++] = li;
    //postfix[temp++] = line.desc + ' ' + line.condition + ' ' + (line.value ? line.value : "");

    if (line.last) {
      // console.log("648 - line.last=", line.last);
      for (let i = 0; i < parseInt(line.last, 10); i++) {
        while (stackarr[topp] !== '﴾') {

          let li = {
            xtra_desc: "",
            condition: popFromStack(),
            xtra_value: "",
            scModuleId: scModuleId
          }
          postfix[temp++] = li; //popFromStack();
          // postfix[temp++] = popFromStack();
        }
        popFromStack();
      }
    }
    // }
  }

  while (stackarr[topp] !== '@') {
    let li = {
      xtra_desc: "",
      condition: popFromStack(),
      xtra_value: "",
      scModuleId: scModuleId
    }
    postfix[temp++] = li; //popFromStack();
    // postfix[temp++] = popFromStack();
  }
  // console.log("651 - postfix=", postfix);
  // console.log("652 - stackarr=", stackarr);
  return postfix;
}


export const getModuleConditions = (t, conditions, noneText = null) => {
  let index = 0;
  let stack = [];

  for (const [i, condition] of conditions.entries()) {

    // console.log("376 - i, condition=", i, condition);
    const cond = condition.condition;
    const display_cond = t('scenarios.conditions.operators.' + cond);
    // console.log("1166 - display_cond=", display_cond, cond);

    if (!cond)
      return {
        error: true,
        text: t('scenarios.conditions.errors.choose', { x: i + 1 })
      };

    const desc = condition.xtra_desc ? `"${condition.xtra_desc}"` : 'NULL';
    const value = condition.xtra_value ? `"${condition.xtra_value}"` : 'NULL';

    if (condition.xtra_desc === 'FAKE_XTRA_DESC_FOR_WHOLE_MODULE_ABSENT' && condition.condition === 'NONE') {
      return {
        error: false,
        text: <span className="operator"> {t('scenarios.module_data.whole_module_absent')}</span>
      };
    }

    switch (cond) {
      case '==':
      case '!=':
      case '<':
      case '>': {
        if (!condition.xtra_desc)
          return {
            error: true,
            text: t('scenarios.conditions.errors.invalid_desc', { op: display_cond })
          };

        if (!condition.xtra_value)
          return {
            error: true,
            text: t('scenarios.conditions.errors.invalid_value', { op: display_cond })
          };

        index += 1;
        stack[index] = {
          topLevel: '',
          notation: <span>{desc} {display_cond} {value}</span>
        };

        break;
      }

      case 'ANY':
      case 'NONE':
      case 'EMPTY': {
        if (!condition.xtra_desc)
          return {
            error: true,
            text: t('scenarios.conditions.errors.invalid_desc', { op: display_cond })
          };

        index += 1;
        stack[index] = {
          topLevel: '',
          notation: <span>{desc}
            <span className="operator"> {display_cond}</span>
          </span>
        };

        break;
      }

      case 'OR':
      case 'AND': {
        if (index < 2)
          return {
            error: true,
            text: t('scenarios.conditions.errors.no_condition', { op: display_cond.replaceAll(/(\u2000)/g, '') })
          };

        else {
          const a = stack[index - 1];
          const b = stack[index];

          const a_val = a.topLevel === cond ? a.notation : <>({a.notation})</>;
          const b_val = b.topLevel === cond ? b.notation : <>({b.notation})</>;

          const item = {
            topLevel: cond,
            notation: <span>
              {a_val}
              <span className="and-or">{display_cond}</span>
              {b_val}
            </span>
          };

          stack[index - 1] = item;
          index -= 1;
        };

        break;
      }

      default:
        return {
          error: false,
          text: t('global.none', { e: 'e' })
        };
    }
  };

  if (index === 1)
    return {
      error: false,
      text: stack[1].notation
    };

  if (index > 1)
    return {
      error: true,
      text: <span className="error">
        {t('scenarios.conditions.errors.unfinished', { count: index })}
        {stack.slice(0, index + 1).map((s, key) => <React.Fragment key={key}>
          <br />&bull; {s.notation}
        </React.Fragment>)}
      </span>
    };

  return {
    error: true,
    text: noneText ?? t('global.none', { e: 'e' })
  };
};






//=================================================================================================================================


export const getScenarioTextOnly = (modules, sequence) => {
  let index = 0;
  let stack = [];

  console.log("1640 - sequence=", sequence);
  for (const seq of sequence) {

    const op = seq.operator;

    let display_op = ""
    if (op)
      display_op = `[OP=\u2042${op}\u2042]`;

    const scModuleId = seq.scenarioModuleId ? `[SCMODULEID=\u2042${seq.scenarioModuleId}\u2042]` : 'NULL';

    switch (op) {
      case 'OR':
      case 'AND': {
        if (index < 2)
          return ("")

        else {
          const a = stack[index - 1];
          const b = stack[index];

          const a_val = a.topLevel === op ? a.notation : '﴾' + (a.notation) + '﴿';
          const b_val = b.topLevel === op ? b.notation : '﴾' + b.notation + '﴿';

          const item = {
            topLevel: op,
            notation: a_val + display_op + b_val
          };

          stack[index - 1] = item;
          index -= 1;
        };

        break;
      }

      default:
        index += 1;
        stack[index] = {
          topLevel: '',
          notation: scModuleId
        };
    }
  };

  if (index === 1)
    return (stack[1].notation)

  if (index > 1)
    return ("")

  return ("");
};


export const getScenarioLines = (scenario) => {

  console.log("1633 - scenario=", scenario);

  const scenarioId = scenario.id;
  const modules = scenario && scenario.modules;
  const mapModules = new Map(modules.map(item => [item.seq, item]));

  let sequence = scenario && scenario.sequence;
  if (sequence === undefined)
    sequence = []; ///// TO DO !!!!


  let text = getScenarioTextOnly(modules, sequence);
  if (text && text[0] && text[0] !== '﴾') {
    text = '﴾' + text + '﴿';
  }
  console.log("1715 - text=", text);

  console.log("1711 - mapModules=", mapModules);
  // const scModuleId = conditions && conditions[0] && conditions[0].scModuleId;

  // //(([DESC="param1"][OP="=="][VALUE="5390416"])[OP="AND"]([DESC="param2"][OP="=="][VALUE="4294901760"]))[OP="OR"]([DESC="closing code"][OP="ANY"])
  let curParenthOpen = 0;
  let curParenthClose = 0;

  let stringInProgress = '';

  let strExtra = "";
  let strFirst = "";
  let scModuleId = "";
  let strCond = "";
  let strLast = "";

  let lines = [];

  let nbSeq = 1;

  // // "([^"]+)"

  // // const regex = /\[([^\]]+)\]/g;  // 
  const regex = /\u2042([^\u2042]+)\u2042/g;  // 

  for (let i = 0; i < text.length; i++) {
    const letter = text[i];

    if (letter === '﴾') {
      curParenthOpen++;
    }
    else if (letter === '﴿') {
      curParenthClose++;
    }
    else {
      if (curParenthOpen) {
        strFirst = (curParenthOpen - 1).toString();
      }
      curParenthOpen = 0;

      if (curParenthClose) {
        strLast = (curParenthClose - 1).toString();

        if (stringInProgress.substring(0, 10) === '[OP=\u2042AND\u2042]') {
          strExtra = "AND";
          stringInProgress = stringInProgress.substring(10);
        }
        else if (stringInProgress.substring(0, 9) === '[OP=\u2042OR\u2042]') {
          strExtra = "OR";
          stringInProgress = stringInProgress.substring(9);
        }

        const tmpExt = stringInProgress.match(regex);
        console.log("55 - tmpExt=", tmpExt);

        scModuleId = tmpExt[0] && tmpExt[0].slice(1, -1);

        // console.log("55 - strDesc=", strDesc, strOp, strValue);
        const line = {
          extra: strExtra,
          first: strFirst,
          text: stringInProgress,
          scModuleId: scModuleId,
          scenarioId: scenarioId,
          last: strLast,
          module: mapModules.get(nbSeq),
          nbSeq: nbSeq++
        }
        lines.push(line);
        stringInProgress = '';
      }
      curParenthClose = 0;

      stringInProgress = stringInProgress + letter;
    }
  }
  if (curParenthClose) {
    strLast = (curParenthClose - 1).toString();

    if (stringInProgress.substring(0, 10) === '[OP=\u2042AND\u2042]') {
      strExtra = "AND";
      stringInProgress = stringInProgress.substring(10);
    }
    else if (stringInProgress.substring(0, 9) === '[OP=\u2042OR\u2042]') {
      strExtra = "OR";
      stringInProgress = stringInProgress.substring(9);
    }

    const tmpExt = stringInProgress.match(regex);

    scModuleId = tmpExt[0] && tmpExt[0].slice(1, -1);

    const line = {
      extra: strExtra,
      first: strFirst,
      text: stringInProgress,
      scModuleId: scModuleId,
      scenarioId: scenarioId,
      last: strLast,
      module: mapModules.get(nbSeq),
      nbSeq: nbSeq++
      // scModuleId: scModuleId
    }
    lines.push(line);
    stringInProgress = '';
  }

  console.log("1829 - lines=", lines);
  return lines;
}


export const getSequencesFromLines = (lines) => {

  // console.log("1825 - getSequencesFromLines=", lines)
  
  let stackarr = [];
  let topp = -1;

  let postfix = [];
  let temp = 0;
  let seq = 1;

  function pushToStack(e) {
    topp++;
    stackarr[topp] = e;
  }

  // Pop function for returning top element
  function popFromStack() {
    if (topp === -1)
      return 0;
    else {
      const popped_ele = stackarr[topp];
      topp--;

      return popped_ele;
    }
  }

  function precedency(pre) {
    if (pre === '@' || pre === '﴾' || pre === '﴿') {
      return 1;
    }
    else if (pre === 'OR') {
      return 2;
    }
    else if (pre === 'AND') {
      return 3;
    }
    return 0;
  }


  function checkP(lines) {
    let totalP = 0;

    for (const line of lines) {
      totalP = totalP + parseInt(line.first, 0);
      totalP = totalP - parseInt(line.last, 0);
    }
    return totalP;
  }

  if (lines === undefined)
    return postfix;

  if (checkP(lines) !== 0)
    return postfix;

  pushToStack('@');

  let scModuleId = "";
  let scenarioId = "";
  for (const line of lines) {

    // console.log("1909 -------------");

    if (scModuleId === "")
      scModuleId = line.scModuleId;

    if (scenarioId === "")
      scenarioId = line.scenarioId;

    // console.log("1888 - line=", line);    

    // if (line.extra || line.first || line.last) {
    if (line.extra) {

      // console.log("625 - line.extra=", line.extra, stackarr[topp], precedency(line.extra) > precedency(stackarr[topp]));
      if (precedency(line.extra) > precedency(stackarr[topp])) {
        pushToStack(line.extra);
      }
      else {
        while (precedency(line.extra) <=
          precedency(stackarr[topp]) && topp > -1) {

          let li = {            
            scModuleId: null,
            operator: popFromStack(),
            scenarioId: line.scenarioId,
            seq: seq++
            // scModuleId: scModuleId
          }
          postfix[temp++] = li; //popFromStack();
        }
        pushToStack(line.extra);
      }
    }

    if (line.first) {
      for (let i = 0; i < parseInt(line.first, 10); i++) {
        pushToStack('﴾');
      }
    }


    let li = {
      operator: null,     
      scModuleId: line.scModuleId,
      scenarioId: line.scenarioId,
      seq: seq++
    }
    postfix[temp++] = li;

    if (line.last) {
      for (let i = 0; i < parseInt(line.last, 10); i++) {
        while (stackarr[topp] !== '﴾') {

          let li = {
            operator: popFromStack(),
            scModuleId: null,
            scenarioId: line.scenarioId,
            seq: seq++
          }
          postfix[temp++] = li; 
        }
        popFromStack();
      }
    }
  }

  while (stackarr[topp] !== '@') {
    let li = {      
      operator: popFromStack(),
      scModuleId: null,
      scenarioId: scenarioId,
      seq: seq++
    }
    postfix[temp++] = li; //popFromStack();
    // postfix[temp++] = popFromStack();
  }
  console.log("1959 - postfix=", postfix);
  console.log("1960 - stackarr=", stackarr);
  return postfix;
}























// DATA-GRID TABLE FUNCTIONS
export const translatedGridFilters = (t) => ({
  filterOperatorActive: t('global.grid.filters.state'),
  filterOperatorValueState: t('global.grid.filters.state'),

  filterOperatorString_Contains: t('global.grid.filters.contains'),
  filterOperatorString_DoesNotContain: t('global.grid.filters.not_contains'),
  filterOperatorString_Equals: t('global.grid.filters.equals'),
  filterOperatorString_DoesNotEqual: t('global.grid.filters.not_equals'),
  filterOperatorString_StartsWith: t('global.grid.filters.starts_with'),
  filterOperatorString_EndsWith: t('global.grid.filters.ends_with'),
  filterOperatorString_IsEmpty: t('global.grid.filters.isEmpty'),
  filterOperatorString_IsNotEmpty: t('global.grid.filters.isNotEmpty'),

  filterOperatorString_Deduplicate: t('global.grid.filters.deduplicate'),

  filterOperatorNumber_Equals: t('global.grid.filters.equals'),
  filterOperatorNumber_DoesNotEqual: t('global.grid.filters.not_equals'),
  filterOperatorNumber_GreaterThanOrEqualTo: t('global.grid.filters.greaterThanOrEqualTo'),
  filterOperatorNumber_GreaterThan: t('global.grid.filters.greaterThan'),
  filterOperatorNumber_LessThanOrEqualTo: t('global.grid.filters.lessThanOrEqualTo'),
  filterOperatorNumber_LessThan: t('global.grid.filters.lessThan'),  
  filterOperatorNumber_IsEmpty: t('global.grid.filters.isEmpty'),
  filterOperatorNumber_IsNotEmpty: t('global.grid.filters.isNotEmpty'),

  filterOperatorDateTime_Equals: t('global.grid.filters.equals'),
  filterOperatorDateTime_DoesNotEqual: t('global.grid.filters.not_equals'),
  filterOperatorDateTime_OnOrAfter: t('global.grid.filters.onOrAfter'),
  filterOperatorDateTime_After: t('global.grid.filters.after'),
  filterOperatorDateTime_OnOrBefore: t('global.grid.filters.onOrBefore'),
  filterOperatorDateTime_Before: t('global.grid.filters.before') 
});


export const activeGridFilter = (t, GridFilterInputValue) => ({
  extendType: 'string',
  filterOperators: [
    {
      value: 'active',
      getApplyFilterFn: (filterItem) => {
        if (!filterItem.value) {
          return null;
        }
        return ({ value }) => filterItem.value === String(value);
      },
      InputComponent: (props) => (
        <GridFilterInputValue
          select {...props}
          SelectProps={{ native: true }}
        >
          <option value="" hidden disabled>{t('global.grid.filters.select')}</option>
          <option value="true">{t('global.grid.filters.yes')}</option>
          <option value="false">{t('global.grid.filters.no')}</option>
        </GridFilterInputValue>
      ),
    },
    // {   
    //   value: 'general_$$_location',   
    //   getApplyFilterFn: (filterItem) => {
    //     console.log('345 - filterItem=', filterItem);

    //     if (!filterItem.value) {
    //       return null;
    //     }
    //     return ({ value }) => filterItem.value === String(value);
    //   },
    //   InputComponent: (props) => (
    //     <GridFilterInputValue
    //       select {...props}
    //       SelectProps={{ native: true }}
    //     >
    //     </GridFilterInputValue>
    //   ),
    // },
  ],
});

export const setLocationGridValues = (t, loc, groups) => {
  loc.deactivation = new Date(loc.deactivation).getTime() ? new Date(loc.deactivation).toISOString().slice(0, 10) : null;
  loc.mceExpiration = new Date(loc.mceExpiration).getTime() ? new Date(loc.mceExpiration).toISOString().slice(0, 10) : null;
  loc.sdsExpiration = new Date(loc.sdsExpiration).getTime() ? new Date(loc.sdsExpiration).toISOString().slice(0, 10) : null;

  loc.dbType = loc.dbType === 1 ? 'SDS' : 'Kiosk';
  loc.group = groups.find(group => group.id === loc.groupId)?.name;

  loc.activityPc = t('global.' + (loc.activityPc ? 'yes' : 'no'));
  loc.activityMobile = t('global.' + (loc.activityMobile ? 'yes' : 'no'));

  return loc;
};

export const changeAdminColumns = ({ view, columns, column, type, value, dispatch }) => {
  // Type can be 'hide', 'order', 'width'
  // View can be 'account', 'group', 'location'

  if (type === 'order') {
    const movedCol = Object.keys(columns).find(col => columns[col].order === value.new);
    dispatch({
      [view + 'Columns']: {
        ...columns,
        [column]: { ...columns[column], [type]: value.new },
        [movedCol]: { ...columns[movedCol], [type]: value.old }
      }
    });
  }

  else {
    dispatch({
      [view + 'Columns']: {
        ...columns,
        [column]: { ...columns[column], [type]: value }
      }
    });
  }
};

export const changeReportingColumns = ({ columns, setWithExtraColumns, setColumns, allColumns, column, type, value, dispatch, eventDispatch, t, scenario, module, mode }) => {
  let newColumns;
  let newAllColumns;

  // console.log("373 - changeReportingColumns=", columns, column, type, value, scenario, module, mode);

  if (type === 'width') {

    // ALL COLUMNS
    newAllColumns = copy(allColumns);
    const colIndexAll = allColumns.findIndex(col => col.field === column);
    newAllColumns[colIndexAll].width = value;

    newColumns = copy(columns);
    const colIndex = newColumns.findIndex(col => col.field === column);

    // console.log("379 - newColumns=", newColumns);
    // console.log("380 - colIndex=", colIndex);

    if (colIndex !== -1) { // Location columns added for ADMINS
    // Don't call API if column width hasn't changed
    if (newColumns[colIndex].width === value) return;

    newColumns[colIndex].width = value;

    // console.log("613 - reportingColumns=", newColumns);
    dispatch({ reportingColumns: newColumns });

      setWithExtraColumns(newAllColumns);
      setColumns(newAllColumns);

      // eventDispatch({reportingColumnsLoaded: true});
      // console.log("993 - reportingColumns...");
  }
  }
  else {
    newColumns = arrayMoveImmutable(columns, value.old - 1, value.new - 1);

    // console.log("620 - reportingColumns=", newColumns);
    dispatch({ reportingColumns: newColumns });

    setWithExtraColumns(newAllColumns);
    setColumns(newAllColumns);
  }

  if (mode === undefined || mode !== "modules") {
    updateColumns(newAllColumns, scenario && scenario.id, 'reporting').then(res => {
      if (!res.success) {
        return toast(decodeHTMLEntities(t('settings.columns.error')), { type: 'error' });
      }

    });
  } else if (mode === "modules") {
    updateColumnsForModule(newAllColumns, module, 'reporting').then(res => {
      if (!res.success) {
        return toast(decodeHTMLEntities(t('settings.columns.error')), { type: 'error' });
      }
    });
  }
};




export const changeReportingSortColumns = ({ model, t, scenario, module, mode }) => {

    // console.log("1010 - changeReportingSortColumns=", model, scenario, module, mode);
  if ( (scenario || module) ) {   

    if (mode === undefined || mode === "scenarios") {
      updateSortModel(model, scenario && scenario.id, 'reporting').then(res => {
        if (!res.success) {
          return toast(decodeHTMLEntities(t('settings.columns.error')), { type: 'error' });
        }
      });
    }
    else if (mode === "modules") {
      updateSortModelForModule(model, module, 'reporting').then(res => {
        if (!res.success) {
          return toast(decodeHTMLEntities(t('settings.columns.error')), { type: 'error' });
        }
      });
    }
  }
};


export var CSV = {

  parse: function (csv, reviver) {
    const delimiter = '`';

    reviver = reviver || function (r, c, v) { return v; };
    var chars = csv.split(''), c = 0, cc = chars.length, start, end, table = [], row;
    while (c < cc) {
      table.push(row = []);
      while (c < cc && '\r' !== chars[c] && '\n' !== chars[c]) {
        start = end = c;
        if ('"' === chars[c]) {
          start = end = ++c;
          while (c < cc) {
            if ('"' === chars[c]) {
              if ('"' !== chars[c + 1]) { break; }
              else { chars[++c] = ''; } // unescape ""
            }
            end = ++c;
          }
          if ('"' === chars[c]) { ++c; }
          while (c < cc && '\r' !== chars[c] && '\n' !== chars[c] && delimiter !== chars[c]) { ++c; }
        } else {
          while (c < cc && '\r' !== chars[c] && '\n' !== chars[c] && delimiter !== chars[c]) { end = ++c; }
        }
        row.push(reviver(table.length - 1, row.length, chars.slice(start, end).join('')));
        if (delimiter === chars[c]) { ++c; }
      }
      if ('\r' === chars[c]) { ++c; }
      if ('\n' === chars[c]) { ++c; }
    }
    return table;
  },

  stringify: function (table, replacer) {
    replacer = replacer || function (r, c, v) { return v; };
    var csv = '', c, cc, r, rr = table.length, cell;
    for (r = 0; r < rr; ++r) {
      if (r) { csv += '\r\n'; }
      for (c = 0, cc = table[r].length; c < cc; ++c) {
        if (c) { csv += ';'; }
        cell = replacer(r, c, table[r][c]);
        if (/[,\r\n"]/.test(cell)) { cell = '"' + cell.replace(/"/g, '""') + '"'; }
        csv += (cell || 0 === cell) ? cell : '';
      }
    }
    return csv;
  }
};


export const getRandomPassword = () => {
  let pass = '';
  const str = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' +
              'abcdefghijklmnopqrstuvwxyz' +
              '0123456789' +
    '!@#$&+';

  for (let i = 1; i <= 18; i++) {
    let char = Math.floor(Math.random() * str.length + 1);

    while (pass.indexOf(str.charAt(char)) !== -1) {
      // console.log("690 - renew", str.charAt(char));
      char = Math.floor(Math.random() * str.length + 1);
    }
    pass += str.charAt(char)
  }
  return pass;
}


// Decode en JS
export const decodeHTMLEntities = (text) => {
  var textArea = document.createElement('textarea');
  textArea.innerHTML = text;
  return textArea.value;
}

// Encode en JS
export const encodeHTMLEntities = (text) => {
  var textArea = document.createElement('textarea');
  textArea.innerText = text;
  return textArea.innerHTML;
}


export const compareVersionStrings = (v1, v2) => {
  // vnum stores each numeric 
  // part of version 
  var vnum1 = 0, vnum2 = 0;

  // loop until both string are 
  // processed 
  for (var i = 0, j = 0; (i < v1.length || j < v2.length);) {
    // storing numeric part of 
    // version 1 in vnum1 
    while (i < v1.length && v1[i] != '.') {
      vnum1 = vnum1 * 10 + (v1[i] - '0');
      i++;
    }

    // storing numeric part of 
    // version 2 in vnum2 
    while (j < v2.length && v2[j] != '.') {
      vnum2 = vnum2 * 10 + (v2[j] - '0');
      j++;
    }

    if (vnum1 > vnum2)
      return 1;
    if (vnum2 > vnum1)
      return -1;

    // if equal, reset variables and 
    // go for next numeric part 
    vnum1 = vnum2 = 0;
    i++;
    j++;
  }
  return 0;
}


export const getDateWithoutTimezone = (value) => {
  const dateWithTimezone = new Date(value);
  const isoDateString = dateWithTimezone.toISOString();

  const isoStringWithoutTimezone = isoDateString.substring(0, isoDateString.length - 1);
  const dateWithoutTimezone = new Date(isoStringWithoutTimezone);

  return dateWithoutTimezone;
}

